import api from './api';

// Demo Management API calls
export const demosService = {
  // Create new demo
  createDemo: async (demoData) => {
    try {
      const response = await api.post('/api/demos', demoData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all demos with filters
  getDemos: async (params = {}) => {
    try {
      const response = await api.get('/api/demos', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get demo by ID
  getDemo: async (id) => {
    try {
      const response = await api.get(`/api/demos/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update demo
  updateDemo: async (id, updateData) => {
    try {
      const response = await api.put(`/api/demos/${id}`, updateData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete demo
  deleteDemo: async (id) => {
    try {
      const response = await api.delete(`/api/demos/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get available slots for a teacher on a specific date
  getAvailableSlots: async (teacherId, date, studentTimezone, extraParams = {}) => {
    try {
      const response = await api.get(`/api/demos/available-slots/${teacherId}`, {
        params: { date, studentTimezone, ...extraParams },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update demo status
  updateStatus: async (id, statusData) => {
    try {
      const response = await api.patch(`/api/demos/${id}/status`, statusData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Search available teachers for a time slot
  searchAvailableTeachers: async (timeSlotData) => {
    try {
      const response = await api.post('/api/demos/search-available-teachers', timeSlotData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSalespeople: async () => {
    const response = await api.get('/api/demos/salespeople');
    return response.data;
  },

  // Add lead to demo
  addLeadToDemo: async (demoId, leadId) => {
    try {
      const response = await api.post(`/api/demos/${demoId}/leads`, { lead_id: leadId });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Remove lead from demo
  removeLeadFromDemo: async (demoId, leadId) => {
    try {
      const response = await api.delete(`/api/demos/${demoId}/leads/${leadId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDemoReadyStudents: async (params = {}) => {
    const response = await api.get('/api/demos/demo-ready-students', { params });
    return response.data;
  },

  addStudentsToDemo: async (demoId, studentIds) => {
    const response = await api.post(`/api/demos/${demoId}/students`, {
      student_ids: studentIds,
    });
    return response.data;
  },

  removeStudentFromDemo: async (demoId, studentId) => {
    const response = await api.delete(`/api/demos/${demoId}/students/${studentId}`);
    return response.data;
  },
};

export default demosService;

